var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 32,
    viewBox: "0 0 242 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M225.36 18.5588V13.9758L219.666 7.38281C219.357 7.02535 218.908 6.81982 218.436 6.81982H210.955L220.607 17.9956C220.916 18.3531 221.365 18.5586 221.837 18.5586L225.36 18.5588Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M210.956 32.0002H218.435C218.908 32.0002 219.357 31.7942 219.666 31.4359L225.36 24.8296V20.2466H221.838C221.365 20.2466 220.916 20.4523 220.607 20.8104L210.956 32.0002Z",
    fill: "#DC4405"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M241.452 6.81982H233.972C233.499 6.81982 233.05 7.02535 232.741 7.38281L227.048 13.9758V18.5586H230.57C231.042 18.5586 231.492 18.3531 231.8 17.9956L241.452 6.81982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M227.048 20.2468V24.8296L232.741 31.4359C233.05 31.7942 233.5 32.0002 233.973 32.0002H241.452L231.801 20.8104C231.492 20.4523 231.042 20.2466 230.57 20.2466L227.048 20.2468Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.9284 24.0262C16.9792 25.7986 15.3312 26.8245 12.6772 26.8245C8.79006 26.8245 5.85874 23.6368 5.85874 19.4096V19.3395C5.85874 15.1523 8.78984 11.9949 12.6772 11.9949C14.8265 11.9949 16.7006 12.8256 18.7533 14.6879L18.9852 14.8986L22.8185 10.4787L22.6134 10.2766C19.8898 7.5945 16.8359 6.39844 12.7119 6.39844C5.23424 6.39844 -0.404663 11.9921 -0.404663 19.4096V19.4799C-0.404663 26.8577 5.1438 32.4209 12.5015 32.4209C16.8367 32.4209 19.8199 31.122 22.7979 27.9365L22.9994 27.7213L19.1457 23.8284L18.9284 24.0262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.3132 16.5415H31.9593V6.81982H25.9419V32.0003H31.9593V22.1382H41.3132V32.0003H47.3306V6.81982H41.3132V16.5415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.6149 15.4004H56.7034L50.3309 32.0003H56.3502L57.8133 28.1109H67.3732L68.8358 32.0003H74.9874L68.6149 15.4004ZM59.5528 23.4852L62.593 15.4023L65.633 23.4852H59.5528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M67.9666 13.7122L62.659 -0.11377L57.3514 13.7122H67.9666Z",
    fill: "#DC4405"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M106.725 6.43018C103.4 6.43018 100.715 7.75654 98.5307 10.4815C97.0419 7.86433 94.4458 6.43018 91.1673 6.43018C87.6042 6.43018 85.4752 8.23059 84.019 10.0411V6.81979H77.8034V32.0003H84.019V17.8957C84.019 14.3973 85.9525 12.1366 88.9449 12.1366C91.8985 12.1366 93.5926 14.1852 93.5926 17.7568V32.0003H99.8085V17.8957C99.8085 14.3435 101.696 12.1366 104.734 12.1366C107.731 12.1366 109.382 14.1489 109.382 17.8029V32.0003H115.598V16.0895C115.598 10.0411 112.281 6.43018 106.725 6.43018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M130.735 6.81982H120.391V32.0003H126.409V24.63H130.209C136.429 24.63 140.447 21.1209 140.447 15.6901V15.6194C140.447 10.2738 136.635 6.81982 130.735 6.81982ZM126.409 12.3111H130.279C132.873 12.3111 134.36 13.5553 134.36 15.7248V15.7951C134.36 17.837 132.762 19.2088 130.384 19.2088H126.409V12.3111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M143.701 32.0003H149.719V28.4275V6.81982H143.701V32.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M166.462 6.39844C158.95 6.39844 153.065 12.1136 153.065 19.4096V19.4799C153.065 26.8577 158.794 32.4209 166.392 32.4209C173.905 32.4209 179.79 26.7055 179.79 19.4094V19.3393C179.79 11.9619 174.06 6.39844 166.462 6.39844ZM159.328 19.3395C159.328 15.1523 162.365 11.9949 166.392 11.9949C170.459 11.9949 173.526 15.1825 173.526 19.4096V19.4799C173.526 23.667 170.49 26.8245 166.462 26.8245C162.395 26.8245 159.328 23.6368 159.328 19.4096V19.3395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M196.769 6.43018C193.798 6.43018 191.39 7.62323 189.435 10.0711V6.82H183.219V32.0005H189.435V17.8957C189.435 14.3973 191.478 12.1366 194.639 12.1366C197.815 12.1366 199.564 14.1489 199.564 17.8029V32.0003H205.78V16.0895C205.78 10.1315 202.327 6.43018 196.769 6.43018Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.d3443947b7ea281d17cdcda4e608257a.svg";
export { ForwardRef as ReactComponent };